/**
 * OneTrust `handleOneTrustLoad` karşılığı.
 * Karar yokken "Tercihler" açıldığında C0002, C0003 ve C0004 işaretliyse kapatılır (hooks/useCookieYesDefaultToggles).
 * CookieYes: C0002 → analytics + performance, C0003 → functional, C0004 → advertisement.
 * `cookieyes-consent` içinde action:yes|no varsa toggle'lara dokunulmaz.
 */
export const COOKIEYES_DEFAULT_OFF_CATEGORIES = ['analytics', 'performance', 'functional', 'advertisement'] as const

export const hasCookieYesDecision = (cookieSource: string): boolean => {
  const parts = (cookieSource || '').split(';')

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i]
    const eq = part.indexOf('=')
    if (eq < 0) continue
    if (part.slice(0, eq).replace(/^\s+|\s+$/g, '') !== 'cookieyes-consent') continue

    let raw = part.slice(eq + 1).replace(/^\s+|\s+$/g, '')
    try {
      raw = decodeURIComponent(raw)
    } catch {
      // bozuk encoding olduğu gibi okunur
    }

    const pairs = raw.split(',')
    for (let j = 0; j < pairs.length; j++) {
      const kv = pairs[j].split(':')
      if ((kv[0] || '').replace(/^\s+|\s+$/g, '') !== 'action') continue
      const action = (kv[1] || '').replace(/^\s+|\s+$/g, '')
      return action === 'yes' || action === 'no'
    }

    return false
  }

  return false
}

const findCategoryCheckboxBySwitch = (doc: Document, category: string): HTMLInputElement | null => {
  const inputs = doc.querySelectorAll<HTMLInputElement>('.cky-switch input[type="checkbox"]')
  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i]
    const id = (input.id || '').toLowerCase()
    const name = (input.getAttribute('name') || '').toLowerCase()
    const value = (input.getAttribute('value') || '').toLowerCase()
    const dataCategory = (input.getAttribute('data-cky-category') || input.closest('[data-cky-category]')?.getAttribute('data-cky-category') || '').toLowerCase()
    if (id === `ckyswitch${category}` || name === category || value === category || dataCategory === category) return input
  }

  return null
}

/** CookieYes her kategori için `ckySwitch<slug>` (tercih merkezi) ve `ckyCategoryDirect<slug>` (kategori önizleme) basar. */
const CATEGORY_CHECKBOX_ID_PREFIXES = ['ckySwitch', 'ckyCategoryDirect']

const findCategoryCheckboxes = (doc: Document, category: string): HTMLInputElement[] => {
  const byId: HTMLInputElement[] = []
  for (let i = 0; i < CATEGORY_CHECKBOX_ID_PREFIXES.length; i++) {
    const input = doc.getElementById(`${CATEGORY_CHECKBOX_ID_PREFIXES[i]}${category}`)
    if (input instanceof HTMLInputElement) byId.push(input)
  }
  if (byId.length > 0) return byId

  const fallback = findCategoryCheckboxBySwitch(doc, category)
  return fallback ? [fallback] : []
}

/** Karar yoksa işaretli anahtarları kapatır. Checkbox henüz yoksa false döner. */
export const uncheckUnsetCookieYesCategories = (categories: readonly string[] = COOKIEYES_DEFAULT_OFF_CATEGORIES, doc: Document = document): boolean => {
  if (hasCookieYesDecision(doc.cookie || '')) return true

  const boxes: HTMLInputElement[] = []
  for (let i = 0; i < categories.length; i++) {
    boxes.push(...findCategoryCheckboxes(doc, categories[i]))
  }

  if (boxes.length === 0) return false

  for (let i = 0; i < boxes.length; i++) {
    const box = boxes[i]
    if (box.disabled || !box.checked) continue
    box.click()
  }

  return true
}
